import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './FakePartner.css';
import Body from '../../components/Body/Body';
import Formbox from '../../components/Formbox/Formbox';


const FakePartner = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const partner = searchParams.get("partner");
    const assetType = searchParams.get("asset_type");
    const tempPass = searchParams.get("temp_pass");
    const userId = searchParams.get("user_id");
    const make = searchParams.get("make");  
    const model = searchParams.get("model");
    const year = searchParams.get("year");
    const handleSubmit = async () => {
        const ENROLLMENT_API_URL = process.env.REACT_APP_BACKEND_BASE;
        try {
            let year_arg = '';  
            if (year){
                year_arg = `/${year}`;
            }
            const response = await fetch(`${ENROLLMENT_API_URL}/add_vehicle_to_simulation/${userId}/${partner}/${assetType}/${make}/${model}${year_arg}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }            });
            if (response.ok ) {
                let url = `/SetPreferences?partner=${partner}&asset_type=${assetType}&temp_pass=${tempPass}&user_id=${userId}`;
                if (year){
                    url = `${url}&year=${year}`;
                }
                window.location.href = url

            }
        } catch (error) {
            console.error("Submit error:", error);
        }
    };

    return (
        <div>
            <Body elements={
                <Formbox elements={
                    <div>
                        <section>
                            <div className="inner">
                                <div className="wizard-header" style={{ textAlign: 'center' }}>
                                    <h1 style={{ color: 'green' }}>Fake Partner Page</h1>
                                    <p>Thank You for enrolling {make} {model} {year}</p>
                                    <p>click the button to continue enrollent with Gridient</p>
                                    <div className="button-container">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                handleSubmit();
                                            }}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                }>
                </Formbox>
            }>
            </Body>
        </div>
    );
}

export default FakePartner;